import { useEffect, useState } from 'react';
import { ICampaign, IPrompt } from '@/types';
import PromptChat from './PromptChat';
import PromptEditor from './PromptEditor';
import PromptVariables from './PromptVariables';
import PromptVersions from './PromptVersions';

interface PromptBuilderProps {
  campaign: ICampaign;
  type: 'task_prompt' | 'summary_prompt' | 'analysis_prompt';
}

const PromptBuilder = ({ campaign, type }: PromptBuilderProps) => {
  const [prompt, setPrompt] = useState<IPrompt>(campaign[type]);
  const [versions, setVersions] = useState<IPrompt[]>([campaign[type]]);

  const [variables, setVariables] = useState(['firstName', 'company', 'productName']);

  useEffect(() => {
    const extractedVariables = (prompt.content.match(/\{\{(\w+)\}\}/g) || []).map((v) => v.replace(/\{\{|\}\}/g, ''));
    setVariables((prevVars) => Array.from(new Set([...prevVars, ...extractedVariables])));
  }, [prompt]);

  const onSave = (e: any) => {
    e.preventDefault();
    setVersions((prevVersions) => [...prevVersions, prompt]);
    // Save the prompt version
  };

  const onChange = (e: any) => {
    e.preventDefault();
    setPrompt((prevPrompt) => ({ ...prevPrompt, content: e.target.value, version: prevPrompt.version + 1 }));
    // Save the prompt version
  };

  return (
    <div className="h-full ">
      <div className="grid h-full grid-cols-3 gap-6">
        <div className="flex flex-col h-full col-span-2 space-y-6">
          <PromptEditor prompt={prompt} onChange={onChange} onSave={onSave} />
        </div>
        <div className="flex flex-col h-full space-y-6">
          <PromptVariables variables={variables} />
          <PromptVersions versions={versions} />
          <PromptChat prompt={prompt} />
        </div>
      </div>
    </div>
  );
};

export default PromptBuilder;
